const hasCompleteProfile = user => {
  const hasUserInfo = ('firstName' in user && user.firstName && user.firstName.length);
  const hasProfileImages = ('images' in user && user.images && user.images.length);

  return hasUserInfo && hasProfileImages; // && hasConversationStarters && hasCoparentRanks;
};



export const getBrowseDataFiltered = (data = [], filters) => {
  if (!filters || !data || data.length === 0) {
    return { data: Array.isArray(data) ? data : [] };
  }

  let { 
    minHeight, 
    maxHeight,
    education, 
    ethnicity, 
    eyeColor, 
    politics, 
    race, 
    religion,
    orientations,
    lookingFor } = filters;
  
  if(!Array.isArray(data)) data = Array(data);
  
  // Convertir altura de pulgadas a centímetros si es necesario
  let minHeightCm = minHeight ? minHeight / 39.7 : null;
  let maxHeightCm = maxHeight ? maxHeight / 39.7 : null;

  // Limpiar filtros de valores "no preference", "none", etc.
  if (education && Array.isArray(education)) {
    education = education.filter(e => e != 'no preference' && e != 'none');
  }
  if (ethnicity && Array.isArray(ethnicity)) {
    ethnicity = ethnicity.filter(e => e != 'none' && e != 'prefer not to say');
  }
  if (orientations && Array.isArray(orientations)) {
    orientations = orientations.filter(e => e != 'none' && e != 'prefer not to say');
  }
  if (religion && Array.isArray(religion)) {
    religion = religion.filter(e => e != 'no preference' && e != 'none');
  }
  if (politics && Array.isArray(politics)) {
    politics = politics.filter(e => e != 'no preference' && e != 'none');
  }
  if (race && Array.isArray(race)) {
    race = race.filter(e => e != 'no preference' && e != 'none');
  }
  if (eyeColor && Array.isArray(eyeColor)) {
    eyeColor = eyeColor.filter(e => e != 'no preference' && e != 'none');
  }

  // Filtrar los datos según las preferencias
  // Nota: El backend debería estar aplicando estos filtros, pero este es un filtro adicional
  // para asegurar que no se muestren usuarios que no cumplan con las preferencias
  const filteredData = data.filter(user => {
    // Filtrar por altura (si está definida)
    if (minHeightCm || maxHeightCm) {
      const userHeight = user.height; // Asumiendo que height está en cm
      if (userHeight) {
        if (minHeightCm && userHeight < minHeightCm) return false;
        if (maxHeightCm && userHeight > maxHeightCm) return false;
      }
    }

    // Filtrar por educación
    if (education && education.length > 0 && user.education) {
      const userEducation = Array.isArray(user.education) ? user.education : [user.education];
      const hasMatchingEducation = userEducation.some(edu => 
        education.some(pref => pref.toLowerCase() === edu.toLowerCase())
      );
      if (!hasMatchingEducation) return false;
    }

    // Filtrar por etnicidad
    if (ethnicity && ethnicity.length > 0 && user.ethnicity) {
      const userEthnicity = Array.isArray(user.ethnicity) ? user.ethnicity : [user.ethnicity];
      const hasMatchingEthnicity = userEthnicity.some(eth => 
        ethnicity.some(pref => pref.toLowerCase() === eth.toLowerCase())
      );
      if (!hasMatchingEthnicity) return false;
    }

    // Filtrar por color de ojos
    if (eyeColor && eyeColor.length > 0 && user.eyeColor) {
      const userEyeColor = Array.isArray(user.eyeColor) ? user.eyeColor : [user.eyeColor];
      const hasMatchingEyeColor = userEyeColor.some(ec => 
        eyeColor.some(pref => pref.toLowerCase() === ec.toLowerCase())
      );
      if (!hasMatchingEyeColor) return false;
    }

    // Filtrar por política
    if (politics && politics.length > 0 && user.politics) {
      const userPolitics = Array.isArray(user.politics) ? user.politics : [user.politics];
      const hasMatchingPolitics = userPolitics.some(pol => 
        politics.some(pref => pref.toLowerCase() === pol.toLowerCase())
      );
      if (!hasMatchingPolitics) return false;
    }

    // Filtrar por raza
    if (race && race.length > 0 && user.race) {
      const userRace = Array.isArray(user.race) ? user.race : [user.race];
      const hasMatchingRace = userRace.some(r => 
        race.some(pref => pref.toLowerCase() === r.toLowerCase())
      );
      if (!hasMatchingRace) return false;
    }

    // Filtrar por religión
    if (religion && religion.length > 0 && user.religion) {
      const userReligion = Array.isArray(user.religion) ? user.religion : [user.religion];
      const hasMatchingReligion = userReligion.some(rel => 
        religion.some(pref => pref.toLowerCase() === rel.toLowerCase())
      );
      if (!hasMatchingReligion) return false;
    }

    // Filtrar por orientación
    if (orientations && orientations.length > 0 && user.orientation) {
      const userOrientation = Array.isArray(user.orientation) ? user.orientation : [user.orientation];
      const hasMatchingOrientation = userOrientation.some(ori => 
        orientations.some(pref => pref.toLowerCase() === ori.toLowerCase())
      );
      if (!hasMatchingOrientation) return false;
    }

    // Filtrar por "looking for" (co-parent vs known donor)
    if (lookingFor && lookingFor.length > 0 && user.lookingFor) {
      const userLookingFor = Array.isArray(user.lookingFor) ? user.lookingFor : [user.lookingFor];
      const searchLookingFor = Array.isArray(lookingFor) ? lookingFor : [lookingFor];
      
      // Verificar si hay coincidencia directa o por transformación (known donor matching)
      const hasMatchingLookingFor = userLookingFor.some(userLF => {
        return searchLookingFor.some(searchLF => {
          // Coincidencia directa
          if (userLF.toLowerCase() === searchLF.toLowerCase()) {
            return true;
          }
          // Transformación para known donor: "looking for a known sperm donor" <-> "open to being a known sperm donor"
          if (
            (userLF.toLowerCase() === "looking for a known sperm donor" && 
             searchLF.toLowerCase() === "open to being a known sperm donor") ||
            (userLF.toLowerCase() === "open to being a known sperm donor" && 
             searchLF.toLowerCase() === "looking for a known sperm donor")
          ) {
            return true;
          }
          // Para co-parent: verificar que ambos tengan valores de co-parent
          const coParentValues = ['co-parent', 'co-parent-romantic', 'co-parent-friends'];
          const userIsCoParent = coParentValues.some(cp => userLF.toLowerCase() === cp);
          const searchIsCoParent = coParentValues.some(cp => searchLF.toLowerCase() === cp);
          if (userIsCoParent && searchIsCoParent) {
            return true;
          }
          return false;
        });
      });
      
      if (!hasMatchingLookingFor) return false;
    }

    return true;
  });

  return {
    data: filteredData
  };
}